import { getStorage, ref } from "firebase/storage";

var temp = "";

function CreatePhotoURL(photoName: string) {
  const storage = getStorage();
  //console.log("in UPD and storage = ", storage);

  // Create a storage reference from our storage service
  //const storageRef = ref(storage);
  //console.log("in UPD and storageref = ", storageRef);
  //const spaceRef = ref(storage, "Fred3.jpg");
  //console.log("in UPD and spaceref = ", spaceRef);
  //
  //
  //console.log("fullPath = ", spaceRef.fullPath);

  //console.log("name = ", spaceRef.name);

  //console.log("bucket = ", spaceRef.bucket);

  // Initialize storage
  //https://firebasestorage.googleapis.com/b/bucket/o/images%20stars.jpg

  const storageName = "https://storage.googleapis.com/";

  const bucketName = "footprints-b291f.appspot.com/";

  //gs://footprints-b291f.appspot.com/Fred3.jpg
  const fullURL = storageName + bucketName + photoName;
  console.log("in CPU and fullURL = ", fullURL);
  return fullURL;
}
export default CreatePhotoURL;
